module.exports = __webpack_public_path__ + "static/media/closeSvg.bc843b92.svg";